import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import { Table } from '@components/table';
import { Paginate } from '@components/table/paginate';
import { HrFlexContainer } from '@components/styles/hr-styles';
import { ACTIONS_COLUMN } from './action-columns';
import { TABLE_COLUMNS } from './constants';
import { FilterRequestTable } from './filter';
import Chip from '../chip/Chip';

export const RequestTable = ({
  response,
  dataTable,
  isLoading,
  isError,
  setFilter,
  setShowModalApproveRequest,
  setShowModalRejectRequest,
  setShowModalModifyRequest,
  setShowModalDeleteRequest,
  setActualRowId,
  onShowToast
}) => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const newDataTable = useMemo(() => [...dataTable], [dataTable]);
  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) =>
      ACTIONS_COLUMN
        ? [
            ...columns,
            ACTIONS_COLUMN(
              navigate,
              setActualRowId,
              setShowModalApproveRequest,
              setShowModalRejectRequest,
              setShowModalModifyRequest,
              setShowModalDeleteRequest,
              onShowToast,
              t
            )
          ]
        : [...columns]
    );
  };
  const RequestTableInstance = useTable(
    {
      columns: TABLE_COLUMNS,
      data: newDataTable,
      initialState: { hiddenColumns: ['_id', 'idVacancy'] },
      manualPagination: true,
      pageCount: response?.pages ?? 0,
      manualSortBy: true
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    tableHooks
  );

  const {
    state: { sortBy }
  } = RequestTableInstance;

  useEffect(() => {
    setFilter((prev) => {
      return { ...prev, sortBy: sortBy[0]?.id, order: sortBy[0]?.desc ? 'desc' : 'asc' };
    });
  }, [sortBy]);

  const onPageChange = (selected) => {
    setFilter((previousState) => {
      return { ...previousState, pageIndex: selected };
    });
  };

  return (
    <>
      <HrFlexContainer
        backgroundColor='#fff'
        flexDirection='column'
        padding='32px'
        margin='0 0 24px 0'
        alignItems='start'
        borderRadius='0 0 8px 8px'
      >
        <FilterRequestTable tableInstance={RequestTableInstance} setFilter={setFilter} total={response?.total ?? 0} />
        <Chip response={response} />
        <Table
          tableInstance={RequestTableInstance}
          isLoading={isLoading}
          isError={isError}
          response={response}
          emptyMessage={t(`requestVacancies.colaborativeSelection.emptyMessage`)}
          dataIntercomTarget='Solicitud-Tabla'
        />
      </HrFlexContainer>
      <Paginate tableInstance={RequestTableInstance} forcePage={response?.pageIndex ?? 0} onPageChange={onPageChange} />
    </>
  );
};
